import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import { fetchCategories } from "../services/categories";

// Постраничный запрос
export const useCategoriesQuery = (
  search: string = "",
  page: number,
  limit: number,
  options?: {
    enabled?: boolean;
  }
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["categories", search, page, limit],
    queryFn: () =>
      fetchCategories({
        search,
        limit,
        offset: (page - 1) * limit,
      }),
    retry: 0,
    enabled: options?.enabled ?? true,
  });
};

// Бесконечная прокрутка
export const useCategoriesInfiniteQuery = (
  search: string = "",
  limit: number,
  options?: {
    enabled?: boolean;
    isForumOnly?: boolean;
  }
) => {
  const isForumOnly = options?.isForumOnly ?? false;
  return useInfiniteQuery({
    queryKey: ["categories-infinite", search, limit, isForumOnly],
    queryFn: ({ pageParam = { limit: limit, offset: 0 } }) =>
      fetchCategories({
        search: search || undefined,
        limit: pageParam.limit,
        offset: pageParam.offset,
        is_forum_only: isForumOnly || undefined,
      }),
    initialPageParam: { limit: limit, offset: 0 },
    getNextPageParam: (lastPage, allPages) => {
      const totalLoaded = allPages.reduce(
        (acc, page) => acc + page.list.length,
        0
      );
      const hasMore = lastPage.list.length === limit;
      return hasMore ? { limit: limit, offset: totalLoaded } : undefined;
    },
    retry: 0,
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
